<template>
<div class="md-layout">
    <div class="md-layout-item">
        <md-card>
            <header-table titlePage="LISTA DE NÍVEIS DE ACESSO" :data="tableData" :columnsPDF="columnsPDF" :headRowsPDF="headRowsPDF" :fildsTXT="fildsTXT" :columnsExcel="columnsExcel" :bodyRowsPDF="bodyRowsPDF" colSpanPDF="4" :totalPDF="total" titleReport="Relátorio de Níveis de Acesso">
                <md-button v-if="permissoes.usuarioCreate" class="md-button md-success md-just-icon md-round" :to="{ name: 'niveis_acessoCreate' }">
                    <i class="fas fa-plus"></i>
                </md-button>
            </header-table>
            <md-card-content>
                <md-table :value="queriedData" class="paginated-table table-hover table-striped">
                    <md-table-toolbar>
                        <div class="md-layout">
                            <div class="md-layout-item md-size-10 md-xsmall-size-100">
                                <md-field>
                                    <label for="pages">Listar</label>
                                    <md-select v-model="pagination.perPage" name="pages">
                                        <md-option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                                            {{ item }}
                                        </md-option>
                                    </md-select>
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-35 md-xsmall-size-100">
                                <md-field>
                                    <label>Pesquisar</label>
                                    <md-input type="search" class="mb-3" clearable placeholder="Nome ou Usuário" v-model="buscar.busca">
                                    </md-input>
                                </md-field>
                            </div>

                            <div class="md-layout-item md-size-15 md-xsmall-size-100">
                                <md-button @click="read()" class="md-site md-round text-right md-sm">
                                    <md-icon>search</md-icon> BUSCAR
                                </md-button>
                            </div>
                            <div class="md-layout-item md-size-35 md-xsmall-size-100">
                                <md-field md-clearable class="md-toolbar-section-end">
                                    <md-input placeholder="Pesquise no resultado da busca aqui." v-model="search" @input="searchOnTable" />
                                </md-field>
                            </div>
                        </div>
                    </md-table-toolbar>

                    <md-table-row slot="md-table-row" slot-scope="{ item }" class="tableRow">
                        <md-table-cell class="uppercase" md-label="ID" style="width: 5%" md-sort-by='id' md-numeric>{{ item.id }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="NOME" style="width: 35%" md-sort-by="nome">{{ item.nome }}</md-table-cell>
                        <md-table-cell class="uppercase" md-label="DESCRIÇÃO" style="width: 55%">{{ item.descricao }}</md-table-cell>
                        <md-table-cell md-label="AÇÕES" style="width: 5%">
                            <md-menu md-direction="bottom-start" class="menuTable">
                                <md-button md-menu-trigger class="md-just-icon md-site md-round">
                                    <md-icon>menu</md-icon>
                                </md-button>

                                <md-menu-content>
                                    <md-menu-item v-if="permissoes.niveis_acessoUpdate" @click="editar(item.id)">
                                        EDITAR <md-icon class="text-warning">edit</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="permissoes.niveis_acessoReadPermissao" @click="permissoesNivelAcesso(item.id)">
                                        PERMISSÕES <md-icon class="text-success">vpn_key</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="permissoes.niveis_acessoDelete" @click="excluir(item.id, item.nome)">
                                        EXCLUIR<md-icon class="text-danger">delete</md-icon>
                                    </md-menu-item>
                                    <md-menu-item v-if="permissoes.niveis_acessoEliminate" @click="apagar(item.id, item.nome)">
                                        DELETAR<md-icon class="text-danger">delete_forever</md-icon>
                                    </md-menu-item>
                                </md-menu-content>
                            </md-menu>

                        </md-table-cell>
                    </md-table-row>
                </md-table>
            </md-card-content>
            <footer-table :from="from" :to="to" :total="total">
                <pagination class="pagination-site" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="total" />
            </footer-table>
        </md-card>
    </div>
</div>
</template>

<script>
import TableSearch from "@/config/mixins/tableSearch";
import HeaderTable from "@/pages/Layout/Extra/HeaderTable";
import FooterTable from "@/pages/Layout/Extra/FooterTable";
import Notify from '@/config/mixins/notify'
import {
    Pagination
} from "@/components";
import preLoader from '@/config/mixins/preLoader';

export default {
    name: 'NiveisAcessoRead',
    components: {
        HeaderTable,
        FooterTable,
        Pagination
    },

    data() {
        return {
            dados: {},
            permissoes: this.$store.state.usuario.permissao,
            rotaDeletar: 'niveis_acessos/',
            rotaExcluir: 'niveis_acessos/excluir/',
            columnsPDF: [20, 70, 90],
            headRowsPDF: ['ID', 'NOME', 'DESCRIÇÃO'],
            fildsTXT: ['id', 'nome', 'descricao'],
            bodyRowsPDF: ['id', 'nome', 'descricao'],
            columnsExcel: [

                {
                    label: "ID",
                    field: "id"
                },
                {
                    label: "NOME",
                    field: "nome",
                    dataFormat: this.upperCaseFormat
                },
                {
                    label: "DESCRIÇÃO",
                    field: "descricao",
                    dataFormat: this.upperCaseFormat
                }
            ],
            search: null,
            tableData: [],
            searchedData: [],
            buscar: {
                busca: ''
            }
        };
    },

    mixins: [TableSearch, Notify, preLoader],

    methods: {
        upperCaseFormat(value) {
            return value.toString().toUpperCase();
        },

        read(pagi) {
            let loader = this.openLoader('dots');
            pagi = pagi || this.$urlAPI + 'niveis_acessos/buscar'
            this.$http.post(pagi, this.buscar)
                .then(response => {
                    if (response.data.status) {
                        this.tableData = response.data.dados
                        this.searchOnTable()
                    } else {
                        this.danger(response.data.message)
                    }
                })
                .catch(e => {
                    this.msgErrors(e)
                })
                .finally(function () {
                    loader.hide();
                });
        },

        searchByName(items, term) {
            if (term) {
                return items.filter(item => this.toLower([item.nome, item.decricao]).includes(this.toLower(term)))
            }
            return items
        },

        editar(id) {
            this.$router.push({
                name: 'niveis_acessoUpdate',
                params: {
                    id: id
                }
            })
        },

        excluir(id, nome) {
            this.handleDelete(id, nome)
        },

        apagar(id, nome) {
            this.deletar = true
            this.handleDelete(id, nome)
        },

        permissoesNivelAcesso(id) {
            this.$router.push({
                name: 'niveis_acessoReadPermissao',
                params: {
                    id: id
                }
            })
        },
    },

};
</script>
